export default "__VITE_ASSET__51fe7444__"